import { toast } from "@vahak/core/dist/components/toast/toast";
import { LOC_STORAGE } from "@vahak/core/dist/constants/misc";
import { getTimeDiffMs } from "@vahak/core/dist/methods/getTimeDiffMs";
import useValidateUserStatus from "./useValidateUserStatus";

export function useToggleCBRModal() {
    const { loginCheck } = useValidateUserStatus();
    // Check if callback is requested less than 24 hours
    const checkCallbackRequestedTimeStamp = () => {
        const oneDay = 60 * 60 * 24 * 1000;
        const callbackTimestamp = window.localStorage.getItem(LOC_STORAGE.callbackRequestedTimestamp);
        // Check if callback is requested less than 24 hours
        if (
            callbackTimestamp === (undefined || null) ||
            getTimeDiffMs(callbackTimestamp, new Date().toISOString()) > oneDay
        ) {
            return true;
        } else {
            return false;
        }
    };

    /**
     * Custom Hooks
     */
    // const { openModal, closeModal } = useHandleModalToggle(["isCallbackRequestPopupVisible"]);

    const toggleCBRModal = () => {
        let isCallbackRequestPopupVisible: boolean = false;
        // if (!isCallbackRequestPopupVisible) {
        if (checkCallbackRequestedTimeStamp()) {
            isCallbackRequestPopupVisible = true;
        } else {
            toast.info("Your request is being processed, we'll get back to you shortly");
            return false;
        }

        return isCallbackRequestPopupVisible;
    };

    return {
        toggleCBRModal: () => loginCheck("none" as any, toggleCBRModal),
        checkCallbackRequestedTimeStamp
    };
}
